var exports = {
  "Pf": "x804f0401--b82735--label",
  "ff": "x804f0401--b82735--pros",
  "qu": "x804f0401--b82735--cons",
};

module.exports = exports;
